import React from 'react';

interface StaticLogoProps {
  size?: number;
  className?: string;
  color?: 'default' | 'white' | 'dark';
}

const ReactiveStackStaticLogo: React.FC<StaticLogoProps> = ({ 
  size = 32, 
  className = "",
  color = 'default'
}) => {
  const getColors = () => {
    switch (color) {
      case 'white':
        return {
          primary: '#FFFFFF',
          secondary: '#E5E7EB',
          accent: '#F3F4F6'
        };
      case 'dark':
        return {
          primary: '#1F2937',
          secondary: '#374151',
          accent: '#4B5563'
        };
      default:
        return {
          primary: '#3178C6',
          secondary: '#61DAFB', 
          accent: '#06B6D4'
        };
    }
  };

  const colors = getColors();

  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer ring */}
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke={colors.secondary}
          strokeWidth="2"
          opacity="0.4"
        />
        
        {/* Middle ring */}
        <circle
          cx="50"
          cy="50"
          r="35"
          fill="none"
          stroke={colors.accent}
          strokeWidth="1.5"
          opacity="0.6"
        />
        
        {/* Central hexagon (TypeScript inspired) */}
        <polygon
          points="50,25 65,40 65,60 50,75 35,60 35,40"
          fill={colors.primary}
          opacity="0.9"
        />
        
        {/* Central core */}
        <circle
          cx="50"
          cy="50"
          r="8"
          fill="#F59E0B"
        />
        
        {/* Stack layers */}
        <rect x="20" y="85" width="60" height="3" rx="1.5" fill={colors.primary} opacity="0.7" />
        <rect x="22" y="89" width="56" height="3" rx="1.5" fill={colors.secondary} opacity="0.7" />
        <rect x="24" y="93" width="52" height="3" rx="1.5" fill={colors.accent} opacity="0.7" />
        
        {/* Orbital points */}
        <circle cx="50" cy="20" r="3" fill={colors.secondary} />
        <circle cx="75" cy="50" r="3" fill={colors.primary} />
        <circle cx="50" cy="80" r="3" fill={colors.accent} />
        <circle cx="25" cy="50" r="3" fill="#8B5CF6" />
      </svg>
    </div>
  );
};

export default ReactiveStackStaticLogo;